import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FiShoppingBag,
  FiCreditCard,
  FiUser,
  FiSun,
  FiMoon,
} from "react-icons/fi";
import { useTheme } from "../../../theme/ThemeProvider";
import { PROFILE_ROUTE } from "../../../routes/constant";

const FooterButton = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const buttons = [
    {
      id: "orders",
      label: "Orders",
      icon: FiShoppingBag,
      path: `${PROFILE_ROUTE}?tab=orders`,
    },
    {
      id: "bank",
      label: "Account Details",
      icon: FiCreditCard,
      path: `${PROFILE_ROUTE}?tab=bank`,
    },
    { id: "profile", label: "Profile", icon: FiUser, path: PROFILE_ROUTE },
  ];

  const handleButtonClick = (button) => {
    navigate(button.path);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      {/* Main footer bar */}
      <div
        className={`
        flex items-center justify-around
        px-4 py-2
        border-t shadow-lg backdrop-blur-md
        ${
          isDarkMode
            ? "bg-gray-900/40 border-gray-800"
            : "bg-white/40 border-gray-200"
        }
      `}
      >
        {/* Navigation Buttons */}
        {buttons.map((button) => (
          <button
            key={button.id}
            onClick={() => handleButtonClick(button)}
            className={`
              flex flex-col items-center justify-center
              py-1 px-3 rounded-lg
              transition-all duration-200
              active:scale-95
              ${
                isDarkMode
                  ? "hover:bg-gray-800 text-gray-300"
                  : "hover:bg-gray-100 text-gray-600"
              }
            `}
          >
            <button.icon className="text-xl mb-0.5" />
            <span className="text-xs font-medium">{button.label}</span>
          </button>
        ))}

        {/* Theme Toggle Button */}
        <button
          onClick={toggleTheme}
          type="button"
          title={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
          aria-label={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
          className={`
            flex flex-col items-center justify-center
            py-1 px-3 rounded-lg
            transition-all duration-200
            active:scale-95
            ${
              isDarkMode
                ? "hover:bg-gray-800 text-gray-300"
                : "hover:bg-gray-100 text-gray-600"
            }
          `}
        >
          {isDarkMode ? (
            <>
              <FiSun className="text-xl mb-0.5" />
              <span className="text-xs font-medium">Light</span>
            </>
          ) : (
            <>
              <FiMoon className="text-xl mb-0.5" />
              <span className="text-xs font-medium">Dark</span>
            </>
          )}
        </button>
      </div>

      {/* Safe area padding for devices with home indicator */}
      <div className="h-[env(safe-area-inset-bottom)] bg-inherit" />
    </div>
  );
};

export default FooterButton;
